// extracted by mini-css-extract-plugin
module.exports = {"LabelValueDropdown":"_2mxXeonkfX-labelValueDropdown-LabelValueDropdown","LabelValueDropdown__nativeFallback":"_1O8xW5RuRV-labelValueDropdown-LabelValueDropdown__nativeFallback"};